import { render, staticRenderFns } from "./NuevaSolicitudPantalla.vue?vue&type=template&id=068eadc9&"
import script from "./NuevaSolicitudPantalla.vue?vue&type=script&lang=ts&"
export * from "./NuevaSolicitudPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports